module.exports = __webpack_public_path__ + "img/ja-logo-login.9bd60006.svg";